import { MenuItem as HeadlesMenuItem, Menu, MenuItems, Popover, PopoverButton, PopoverPanel } from '@headlessui/react'
import { IconMoon, IconSun } from '@swaggerhub-portal/component-library'
import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'
import { twMerge } from 'tailwind-merge'

import { MODE } from '../DarkMode/constants'
import { useDarkMode } from '../DarkMode/hook'
import { TopBarMenuLink } from '~/components/TopBarMenuLink'
import darkMode from '~/images/modes/dark-mode.svg'
import lightMode from '~/images/modes/light-mode.svg'
import systemMode from '~/images/modes/system-mode.svg'

const MenuItem = ({ content, menuFor, onClick, close }: { content: any, menuFor: string, onClick: (menuFor: string) => void, close: () => void }) => (
  <HeadlesMenuItem>
    <button
      className={
        twMerge('text-neutral-70 dark:text-neutral-40 group flex w-full px-4 py-1.5 text-body2 items-center whitespace-nowrap first:rounded-t-md last:rounded-b-md',
          'hover:bg-accent-10 dark:hover:bg-neutral-90',
        )
      }
      onClick={() => {
        onClick(menuFor)
        close()
      }}
    >
      {content}
    </button>
  </HeadlesMenuItem>
)

const ModeItem = ({ image, text, className = '' }) => (
  <span className={clsx('flex pt-[6px] w-52 items-center', className)}>
    <img src={image} alt={text} />
    <span className="ml-4">{text}</span>
  </span>
)

export const ProfileDarkMode = ({ close }) => {
  const { t } = useTranslation()

  const { setMode, isDark } = useDarkMode()

  const modeToggleItems = [{
    name: MODE.LIGHT,
    content: <ModeItem image={lightMode} text={t('components.ui.modeToggle.light')} />,
  }, {
    name: MODE.DARK,
    content: <ModeItem image={darkMode} text={t('components.ui.modeToggle.dark')} />,
  }, {
    name: MODE.SYSTEM,
    content: <ModeItem image={systemMode} text={t('components.ui.modeToggle.system')} className="pb-[6px]" />,
  }]

  const toggleDarkMode = (mode: string) => setMode(mode as MODE)

  return <>
    <div className="mx-4 border-b border-b-neutral-20 dark:border-b-neutral-80" />
    <Popover className="relative flex w-full text-left z-[49] flex-1">
      <PopoverButton className="w-full outline-none">
        <TopBarMenuLink key={t('components.profile.buttons.mode.label')} icon={isDark() ? <IconMoon /> : <IconSun />} label={t('components.profile.buttons.mode.label')} isSubmenu={true} />
      </PopoverButton>
      <PopoverPanel>
        <Menu>
          <MenuItems static className="absolute top-0 right-0 min-w-full origin-top-right bg-white dark:bg-neutral-95 rounded-md shadow-[0_2px_4px_0_rgba(0,0,0,0.12)] border-0 ring-black focus:outline-none">
            <Popover className="relative">
              <PopoverButton className="w-full outline-none" as={'div'}>
                <PopoverPanel static>
                  <Menu>
                    <MenuItems static className="absolute top-0 max-h-[25rem] overflow-auto bg-white dark:bg-neutral-95 right-[calc(100%+4px)] min-w-[139px] rounded-md shadow-[0_2px_4px_0_rgba(0,0,0,0.12)] border-0 ring-black focus:outline-none dark:border dark:border-neutral-80">
                      {modeToggleItems.map(item => <MenuItem key={item.name} content={item.content} onClick={toggleDarkMode} menuFor={item.name} close={close} />)}
                    </MenuItems>
                  </Menu>
                </PopoverPanel>
              </PopoverButton>
            </Popover>
          </MenuItems>
        </Menu>
      </PopoverPanel>
    </Popover >
  </>
}